import { useBooleanState } from "~/common/hooks/useBooleanState";
import { useCallback } from "react";
import { addMessage } from "~/features/toasts/redux/actions";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

export function useResetPasswordLogic() {
  const { val: isResetPopupOpen, setTrue: openResetPopup, setFalse: closeResetPopup } = useBooleanState(false);

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const onResetSuccess = useCallback(
    (globalErrors: string[]) => {
      closeResetPopup();
      if (globalErrors.length > 0) {
        globalErrors.forEach((error) => {
          dispatch(addMessage("error", error));
        });
      } else {
        dispatch(addMessage("info", t("forgottenPwd.linkSent")));
      }
    },
    [dispatch, t, closeResetPopup],
  );

  return {
    isResetPopupOpen,
    openResetPopup,
    closeResetPopup,
    onResetSuccess,
  };
}
